import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1ac364b30626415905d4bc189575cb26.js')["default"];

var scope_2 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1afca29e2d35399a39c1b5399d224d48.js')["default"];

var scope_3 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/31ce896dbea51a9c149624a43253e2d4.js')["default"];

var scope_4 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4a6e43e4a1c4c902aeeec77cc42ce419.js')["default"];

var scope_5 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4aff1487176b7bfacd56293344764524.js')["default"];

var scope_6 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4d3fb86f7b55871bcd804ccc544972cf.js')["default"];

var scope_7 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/60784d6db15a2905e7d7ce81606906a4.js')["default"];

var scope_8 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/67c91dfc089161d3a401eb71efc78942.js')["default"];

var scope_9 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/94e36a630136f4f1f11364c09aa2b1ba.js')["default"];

var scope_10 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a2f1e5ee00f40de49e62314705538faa.js')["default"];

var scope_11 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/acabce13c19663ef3002c51c790f06ef.js')["default"];

var scope_12 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aff4ff878bf661168e21fe8b380a7b10.js')["default"];

var scope_13 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b108ed7c1b85609ec8a0d0c9c1b4d667.js')["default"];

var scope_14 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c9e552315369f3de3547eabcd1c823f5.js')["default"];

var scope_15 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e0801ddee880b0e9f3d9c8dc47e94112.js')["default"];

var scope_16 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e28e8b6ebe4dc3bd81c36417056b878e.js')["default"];

var scope_17 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ec59f859cdbe2143a9aca35d84a587ef.js')["default"];

var scope_18 = require('/home/runner/work/gwen-react-components/gwen-react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fcc67931f7873aa232601bcb0f0f619c.js')["default"];

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}